
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"56","height":"56","viewBox":"0 0 56 56","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M52 27.788v.425c-.102 11.715-8.598 21.427-19.766 23.415V4.373C43.402 6.361 51.898 16.073 52 27.788z","fill":"#C2C6E0"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M40.706 48.365A23.888 23.888 0 0 1 28 52C14.745 52 4 41.255 4 28S14.745 4 28 4c3.714 0 7.23.843 10.369 2.35A7.975 7.975 0 0 1 40.706 12v36.365z","fill":"url(#a)"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M4.668 33.647h25.943c1.675 0 3.036 1.34 3.036 3.007v14.678a24.054 24.054 0 0 1-5.48.667h-.335c-11.236-.077-20.637-7.874-23.164-18.352z","fill":"#FC4714"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M5.055 20.94a23.851 23.851 0 0 1 1.764-4.235h25.828a1 1 0 0 1 1 1v2.235a1 1 0 0 1-1 1H5.055zM4 28c0-1.446.128-2.861.373-4.236h16.98a1 1 0 0 1 1 1v2.235a1 1 0 0 1-1 1H4z","fill":"#262626"}}),_c('defs',[_c('linearGradient',{attrs:{"id":"a","x1":"22.353","y1":"4","x2":"22.353","y2":"52","gradientUnits":"userSpaceOnUse"}},[_c('stop',{attrs:{"stop-color":"#DBDEEF"}}),_c('stop',{attrs:{"offset":"1","stop-color":"#fff"}})])])])
          )
        }
      }
    